import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { activeRuleCount, codebaseStatusLabel, countPhrase, relativeMoment } from "./workspaceOverviewModel";

export default function WorkspaceCodebaseList({ codebases = [], canConnect = false, onAddCodebase }) {
  return (
    <section className="rr-codebase-section" aria-labelledby="codebases-title">
      <header>
        <h2 id="codebases-title">Codebases</h2>
        {canConnect ? <button type="button" className="rr-button secondary" onClick={onAddCodebase}>Add codebase</button> : null}
      </header>
      {codebases.length === 0 ? (
        <div className="rr-codebase-empty">
          <h3>Connect your first codebase</h3>
          <p>Add a public repository instantly, or connect GitHub for private repositories and pull-request Checks.</p>
          {canConnect ? <button type="button" className="rr-button" onClick={onAddCodebase}>Add codebase</button> : null}
        </div>
      ) : (
        <table className="rr-codebase-table">
          <thead>
            <tr>
              <th scope="col">Codebase</th>
              <th scope="col">Status</th>
              <th scope="col">Product rules</th>
              <th scope="col">Last activity</th>
              <th scope="col"><span className="rr-sr">Open</span></th>
            </tr>
          </thead>
          <tbody>
            {codebases.map((repo) => {
              const when = relativeMoment(repo.lastReviewedAt);
              const href = `/brain?repository=${encodeURIComponent(repo.id)}`;
              return (
                <tr key={repo.id} className={`is-${repo.status}`}>
                  <th scope="row">
                    <Link to={href} aria-label={`${repo.owner}/${repo.name}`}>
                      {repo.name}
                      <span className="rr-codebase-owner" aria-hidden="true">{repo.owner}</span>
                    </Link>
                  </th>
                  <td><span className={`rr-status-pill is-${repo.status}`}>{codebaseStatusLabel(repo.status)}</span></td>
                  <td>{countPhrase(activeRuleCount(repo), "rule")}</td>
                  <td>{when.absolute ? <time dateTime={repo.lastReviewedAt} title={when.absolute}>{when.sentence}</time> : when.sentence}</td>
                  <td><ChevronRight size={16} aria-hidden="true" /></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </section>
  );
}
